<template>
  <div class="posters">
    <div class="posters__header">
      <div class="posters__title-wrapper">
        <div class="posters__title">Posters</div>
      </div>
    </div>
    <div class="posters__content">
      <div class="posters__slider" ref="sliderContainer">
        <div class="posters__track" ref="track">
          <div v-for="(poster, index) in posters" :key="index" class="posters__item">
            <img class="posters__img" :src="poster.image" alt="Movie Poster" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Posters',
  props: {
    posters: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentIndex: 0,
      visibleItems: 3,
      totalItems: 0,
      scrollLeft: 0,
      scrollWidth: 0,
      containerWidth: 0,
      isDragging: false,
      startX: 0,
      scrollLeft_start: 0
    };
  },

};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.posters {
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;

	&__header {
		padding: 0 rem(80);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;
		width: 100%;
	}

	&__title-wrapper {
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #ffffff;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;
	}

	&__content {
		padding: 0 rem(80);
		width: 100%;
		position: relative;
	}

	&__slider {
		position: relative;
		width: 100%;
		overflow: hidden;
	}

	&__track {
		display: flex;
	}

	&__item {
		flex-shrink: 0;
		height: rem(340);
		border-radius: rem(16);
		aspect-ratio: 55/34;
		position: relative;
		overflow: hidden;
	}

	&__img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.posters {
		// PC端特定样式
		&__track {
			display: flex;
			flex-direction: row;
			gap: rem(20);
			align-items: flex-start;
			justify-content: flex-start;
			position: relative;
			overflow-x: auto;
			overflow-y: hidden;
			scrollbar-width: thin; /* Firefox */
			-ms-overflow-style: none; /* IE and Edge */
			scroll-behavior: smooth;
			padding-bottom: rem(12); /* 为滚动条留出空间 */
			scrollbar-color: rgba(#fff, 0.5) #000;
		}
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.posters {
		&__header {
			padding: 0 rem(16);
		}

		&__content {
			padding: 0 rem(16);
		}

		&__item {
			width: rem(260);
			height: rem(160);
		}

		&__track {
			display: flex;
			flex-direction: row;
			gap: rem(20);
			align-items: flex-start;
			justify-content: flex-start;
			position: relative;
			overflow-x: auto;
			overflow-y: hidden;
			scrollbar-width: none; /* Firefox */
			-ms-overflow-style: none; /* IE and Edge */
			scroll-behavior: smooth;
			&::-webkit-scrollbar {
				display: none; /* Chrome, Safari, Opera */
			}
		}
	}
}
</style> 